import functionSlice from './functionSlice';

export { default as functionOp } from './operations';

export default functionSlice;
